import formatErrorMessage from "../../../utils/formatErrorMessage.js";
import * as React from "react";
const MenuPortalContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") MenuPortalContext.displayName = "MenuPortalContext";
function useMenuPortalContext() {
  const value = React.useContext(MenuPortalContext);
  if (value === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Portal> is missing." : formatErrorMessage(32));
  }
  return value;
}
export {
  MenuPortalContext,
  useMenuPortalContext
};
//# sourceMappingURL=MenuPortalContext.js.map
